import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useNewSimilarItemsCTAExperiment = () => {
    const hasNewSimilarItemsControl = useAmplitudeExperimentBase(
        AmplitudeExperiments.NewSimilarItemsCTA,
        AmplitudeVariants.NewSimilarItemsCTA.Control
    );

    const hasNewSimilarItemsIconCTA = useAmplitudeExperimentBase(
        AmplitudeExperiments.NewSimilarItemsCTA,
        AmplitudeVariants.NewSimilarItemsCTA.IconCTA
    );

    const hasNewSimilarItemsTextCTA = useAmplitudeExperimentBase(
        AmplitudeExperiments.NewSimilarItemsCTA,
        AmplitudeVariants.NewSimilarItemsCTA.TextCTA
    );

    return {
        hasNewSimilarItemsControl,
        hasNewSimilarItemsIconCTA,
        hasNewSimilarItemsTextCTA,
    };
};
